import {
  insuredObjectsService,
  type InsuredObjectType,
} from '@/services/insured-objects';
import { useQuery } from '@tanstack/react-query';

type UseInsuredObjectsParams = {
  enabled?: boolean;
};

export function useInsuredObjects({
  enabled = true,
}: UseInsuredObjectsParams = {}) {
  return useQuery<InsuredObjectType[], Error>({
    queryKey: ['insured-objects'],
    queryFn: async () => {
      const response = await insuredObjectsService.getInsuredObjects();

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar tipos do objeto segurado'
        );
      }

      return response.data.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
